import { useAppDispatch } from '../../app/hooks';
import styles from './switch-account.module.css';
import { Card, CardContent } from 'shared-components';
import { useNavigate } from 'react-router-dom';
import { useGetAccountsQuery } from './accounts.api';
import { useSwitchAccountMutation } from '../login/login.api';
import { setToken } from '../login/authSlice';
import { Selectable } from '../selectable/selectable';
import { topshotsAPI } from '../../app/api';

export const SwitchAccount = () => {
  const { isFetching, isLoading, data } = useGetAccountsQuery();
  const nav = useNavigate();
  const dispatch = useAppDispatch();
  const [
    switchAccounts, // This is the mutation trigger
  ] = useSwitchAccountMutation();
  return (
    <div className={styles.container}>
      <Card className={styles.card}>
        <CardContent standalone={true}>
          <h1 className={styles.title}>Select Account</h1>
          {isFetching || isLoading ? (
            <p>Loading...</p>
          ) : (
            <ul className={styles.accountList}>
              {data?.map((account) => (
                <li
                  key={account._id.toString()}
                  className={styles.accountList__item}
                >
                  <Selectable
                    onClick={async () => {
                      const result = await switchAccounts({
                        accountId: account._id.toString(),
                      });
                      if ('error' in result) {
                        console.error(result.error);
                      } else if ('data' in result) {
                        dispatch(topshotsAPI.util.resetApiState());
                        dispatch(setToken(result.data.token));
                        nav('/');
                      }
                    }}
                  >
                    {account.name}
                  </Selectable>
                </li>
              ))}
            </ul>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
